import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenter, FlexColCenter } from '../../Defaults/Flexbox/Flexbox';
import { Icon } from '../../Defaults/Defaults';
import { __ } from 'react-i18n';
import reactUseCookie from 'react-use-cookie';

interface Props {
  key?: string;
  isOnSearchPage?: boolean;
}

function SearchOnlySwitch({ key, isOnSearchPage }: Props) {
  const [searchOnlyInCodes, setSearchOnlyInCodes] = reactUseCookie(
    'search_only_in_codes',
    '0',
  );

  const labelKey = isOnSearchPage ? 'search-page-toggle' : 'toggle';
  const handleChange = () => {
    setSearchOnlyInCodes('0' === searchOnlyInCodes ? '1' : '0');
  };

  return (
    <Wrapper isOnSearchPage={isOnSearchPage}>
      <InputWrapper>
        <Input
          type="checkbox"
          name="toggle"
          id={labelKey}
          onChange={handleChange}
          checked={searchOnlyInCodes === '1'}
        />
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <InputLabel
          htmlFor={labelKey}
          className="toggle-label block overflow-hidden h-6 rounded-full 
        bg-borderColor cursor-pointer"
        />
      </InputWrapper>
      <BottomLabel
        htmlFor={labelKey}
        className="text-13 lg:text-15 text-textSecondary"
      >
        {__('Hľadať iba vo vlastných kódoch')}
      </BottomLabel>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenter)<{ isOnSearchPage?: boolean }>`
  margin-right: ${rem(16)};
  margin-top: ${rem(16)};
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: auto;
  color: ${({ theme }) => theme.colors.textPrimary};

  ${({ theme }) => theme.media(0, 924)} {
    padding: ${props => (props.isOnSearchPage ? rem(0) : rem(16))};
    padding-top: 0;
  }
`;

const InputWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: ${rem(40)};
  margin-right: ${rem(8)};
  vertical-align: middle;
  user-select: none;
`;

const Input = styled.input`
  position: absolute;
  display: block;
  width: ${rem(16)};
  height: ${rem(16)};
  border-radius: 9999px;
  background-color: white;
  border: ${rem(4)};
  border-color: ${({ theme }) => theme.colors.borderColor};
  appearance: none;
  cursor: pointer;

  &:checked {
    right: 0;
    border-color: ${({ theme }) => theme.colors.primary};
  }

  &:checked + .toggle-label {
    background-color: ${({ theme }) => theme.colors.primary};
  }
`;

const InputLabel = styled.label`
  display: block;
  overflow: hidden;
  height: ${rem(22)};
  border-radius: 9999px;
  background-color: rgb(193 205 217);
  cursor: pointer;
`;

const BottomLabel = styled.label`
  display: block;
  cursor: pointer;
`;

export { SearchOnlySwitch };
